export const USER_FIELD_KEYS = {
  ID: "id",
  WP_USER_ID: "wp_user_id",
  BLOG_ID: "blog_id",
  FIRST_NAME: "first_name",
  LAST_NAME: "last_name",
  ROLE: "role",
  ENROLLMENT_STATUS: "enrollment_status",
  GRADE: "grade",
  HOMEROOM: "homeroom",
  STUDENT_ID: "student_id",
  EXTERNAL_ID: "external_id",
  SYNC_SOURCE: "sync_source",
  LAST_SYNCED_AT: "last_synced_at",
  CREATED_AT: "created_at",
  UPDATED_AT: "updated_at",
  USER_EMAIL: "user_email",
  USER_LOGIN: "user_login",
} as const;

export type SiteUser = {
  [USER_FIELD_KEYS.ID]: number;
  [USER_FIELD_KEYS.WP_USER_ID]: number;
  [USER_FIELD_KEYS.BLOG_ID]: number;
  [USER_FIELD_KEYS.FIRST_NAME]: string;
  [USER_FIELD_KEYS.LAST_NAME]: string;
  [USER_FIELD_KEYS.ROLE]?: string | null;
  [USER_FIELD_KEYS.GRADE]: number | null;
  [USER_FIELD_KEYS.HOMEROOM]: string | null;
  [USER_FIELD_KEYS.ENROLLMENT_STATUS]: string;
  [USER_FIELD_KEYS.STUDENT_ID]: string | null;
  [USER_FIELD_KEYS.EXTERNAL_ID]: string | null;
  [USER_FIELD_KEYS.SYNC_SOURCE]: string;
  [USER_FIELD_KEYS.LAST_SYNCED_AT]: string | null;
  [USER_FIELD_KEYS.CREATED_AT]: string;
  [USER_FIELD_KEYS.UPDATED_AT]: string;
  [USER_FIELD_KEYS.USER_EMAIL]: string;
  [USER_FIELD_KEYS.USER_LOGIN]: string;
};
